import { render, staticRenderFns } from "./pbProportion.vue?vue&type=template&id=5e3af044&"
import script from "./pbProportion.vue?vue&type=script&lang=js&"
export * from "./pbProportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3af044')) {
      api.createRecord('5e3af044', component.options)
    } else {
      api.reload('5e3af044', component.options)
    }
    module.hot.accept("./pbProportion.vue?vue&type=template&id=5e3af044&", function () {
      api.rerender('5e3af044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/pbProportion.vue"
export default component.exports